/*eslint-disable*/ export const messages = JSON.parse("{\"pill.aria.openFilter\":[\"Åpne filter\"],\"pill.aria.removeFilter\":[\"Fjern filter \",[\"label\"]]}");
//# sourceMappingURL=messages.mjs.map